import React, { useState, useEffect } from "react";
import { Button } from "semantic-ui-react";
// import { Link } from "react-scroll";
import { Link as RouteLink } from "react-router-dom";
// components
// import Navbar from "../../components/general/Navbar";
import Footer from "../components/general/Footer";
import ImageGallery from "../components/ImageGallery";
import { Grid, Label, Image, Container, Header } from "semantic-ui-react";

// others
import { GAPageView, initGA } from "../index";
import ContactFormAPWalkIn from "./ContactFormAPWalkIn";

export default function APwalkin() {
    const [contacting, setContacting] = useState(false);

    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    return (
        <div className="website" style={{ fontFamily: "Metropolis Regular" }}>
            {/* <Navbar linkBack="/"/> */}
            <div className="navigation" style={{ marginBottom: "1rem" }}>
                <span className="navigation-logo">
                    <RouteLink to={"/"}>
                        <Image
                            className="navlogo"
                            src="/images/logos/logo_dark_version.png"
                            width="40%"
                        />
                    </RouteLink>
                </span>
            </div>
            <div className="banner-wrapper">
                <div
                    className="banner-container"
                    style={{
                        backgroundImage: `url(/images/public/apbusiness/apbusiness_banner.jpg)`,
                        backgroundPosition: "center 40%",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        height: "80vH",
                    }}
                />

                <div className="back" style={{ maxWidth: "45rem" }}>
                    <div>
                        <Label
                            style={{ color: "white", background: "#ff0000" }}
                        >
                            {" "}
                            #APwalkIn{" "}
                        </Label>
                    </div>
                    <div
                        className="text"
                        style={{
                            paddingBottom: "0.2rem",
                            paddingTop: "0.5rem",
                        }}
                    >
                        <span
                            style={{
                                fontSize: "2rem",
                                fontFamily: "Metropolis Bold",
                            }}
                        >
                            Ponúkaš aktivity ?
                        </span>
                    </div>
                    <ul
                        style={{
                            paddingLeft: "1rem",
                            marginBottom: "1.5rem",
                            listStyleType: "none",
                        }}
                    >
                        <li class="custom-bullet">
                            Prevádzkuješ pohybové, športové, edukačné, kultúrne a historické aktivity?
                        </li>
                        <li class="custom-bullet">
                            Nebaví ťa tlačiť prachy do boostingu, reklám, cieľoviek, kade-tade po sociálnych sieťach a hľadať si nových klientov, či návštevníkov?
                        </li>
                        <li class="custom-bullet">
                            Nerieš, ActivityPoint je tu, aby ti našiel nové ľudské zdroje, ktoré ťa radi objavia... keď o tebe budú vedieť.
                        </li>
                    </ul>
                </div>
            </div>

            <Container>
                <Grid className="section" relaxed stackable>
                    <Grid.Row columns={3} centered style={{ marginTop: "0" }}>
                        <Grid.Column style={{ textAlign: "center" }}>
                            <Image
                                src="/images/icons/AP_Map_Pointer_business_terms.svg"
                                style={{ marginBottom: "1rem", width: "50px" }}
                                centered
                            />
                            <div>
                                <span
                                    style={{
                                        fontSize: "1.3rem",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Zvýrazníme ťa
                                </span>
                                <p style={{ marginTop: "0.5rem" }}>
                                    užívateľ hľadá #coponukaokolie na mape a u teba nájde aktuálnu ponuku aktivít na predaj. Túto aktivitu si vie priamo cez našu platformu ihneď kúpiť. Aktivity, ktoré môžeš na našej mape ponúkať sú po dohode s nami šité na mieru tvojmu biznisu: gymu, hradu, saune, jazde na koni, výletom na lodi, lekciám jógy či ochutnávkam vín....
                                </p>
                            </div>
                        </Grid.Column>
                        <Grid.Column style={{ textAlign: "center" }}>
                            <Image
                                src="/images/icons/AP_Map_Pointer_business_terms.svg"
                                style={{ marginBottom: "1rem", width: "50px" }}
                                centered
                            />
                            <div>
                                <span
                                    style={{
                                        fontSize: "1.3rem",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Informujeme
                                </span>
                                <p style={{ marginTop: "0.5rem" }}>
                                    potenciálny klient dostane o tebe všetky potrebné informácie v jednom bode, vrátane tvojich sociálnych sietí. Všetky tieto informácie vie jednoducho zdieľať ďalej vrátane aktuálnej predajnej ponuky, ktorá ho práve zaujala.
                                </p>
                            </div>
                        </Grid.Column>
                        <Grid.Column style={{ textAlign: "center" }}>
                            <Image
                                src="/images/icons/AP_Map_Pointer_business_terms.svg"
                                style={{ marginBottom: "1rem", width: "50px" }}
                                centered
                            />
                            <div>
                                <span
                                    style={{
                                        fontSize: "1.3rem",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Navigujeme
                                </span>
                                <p style={{ marginTop: "0.5rem" }}>
                                    keď ťa potenciálny klient na mape našiel a tvoja ponuka sa mu tak páčila, že si ju kúpil, jednoducho sa naviguje na aktivitu.
                                </p>
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={1} centered>
                        <Grid.Column id="about-activitypoint">
                            <div
                                style={{
                                    color: "white",
                                    background: "#ff0000",
                                    padding: "1rem",
                                    marginBottom: "2rem",
                                    borderRadius: "5px",
                                }}
                            >
                                <Header
                                    as="h2"
                                    textAlign="center"
                                    style={{
                                        fontSize: "2rem",
                                        marginTop: "2rem",
                                        color: "white",
                                    }}
                                >
                                    Ako to celé funguje ?
                                </Header>
                                <p
                                    style={{
                                        width: "90%",
                                        margin: "1.5rem auto",
                                        textAlign: "center",
                                        fontSize: "1.15rem",
                                        color: "white",
                                    }}
                                >
                                    Webová platforma ActivityPoint za pomoci bodov zobrazovaných na mape, zobrazí tvoju ponuku potenciálnemu klientovi. Ponuku si záujemca podrobne odfiltruje prostredníctvom kategórie, v ktorej budeš po dohode zaradený. Si blízko záujemcu? Ten vidí práve tvoju ponuku. Vie kde sa nachádzaš, čo ponúkaš a všetky tvoje sociálne siete, na ktorých si sa tak nadrel. Bez reklám a spamov, jedinečný bod na mape s tvojim biznisom odpovedá ihneď na dopyt budúceho klienta, ktorý hľadá niečo dostupné, nové, zaujímavé, iné. Vyhľadávanie aktivít v okolí prostredníctvom platformy ActivityPoint šetrí čas pričom potenciálny klient nepotrebuje u nás žiadnu registráciu aby sa mu zobrazilo #coponukaokolie na mape. Inzeruj svoje aktivity v #APwalkIn a získaj viac nových možností ako svoje aktivity predávať a komu ich ponúkať.
                                </p>
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row
                        columns={2}
                        centered
                        style={{ marginTop: "1rem" }}
                    >
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <h2>
                                {/* Inzeruj svoje aktivity v #APwalkIn a získaj viac */}
                            </h2>
                            <p style={{ lineHeight: "1rem" }}>
                                <ul
                                    style={{
                                        paddingLeft: "1rem",
                                        marginBottom: "1.5rem",
                                        listStyleType: "none",
                                    }}
                                >
                                    <li class="custom-bullet">
                                        Ideme v 3 režimoch, kedy podiel z predaja pre náš biznis vždy predstavuje 30%:
                                        <ul>
                                            <li>
                                                APwalkIn – predáme tvoje slabé časy klientovi a niečo navyše
                                            </li>
                                            <li>
                                                APwalkInSpecial – predáme balík tvojich služieb a niečo navyše
                                            </li>
                                            <li>
                                                APwalkInVIP -  predáme balík tvojich extra služieb a niečo navyše
                                            </li>
                                        </ul>
                                        <br />
                                    </li>
                                    <li class="custom-bullet">
                                        Ak máš otázky ohľadne ďalších podmienok zobrazovania na mape - kontaktuj nás prostredníctvom nezáväznej registrácie, radi pokecáme, prípadne sa stretneme a poradíme.
                                        <br />
                                    </li>
                                    <li class="custom-bullet">
                                        Všetky úkony spojené s tvojim bodom na mape sú na našich pleciach. Tak na čo čakáš ?
                                        <br />
                                    </li>
                                    <li class="custom-bullet">
                                        Nezáväznú žiadosť o objednávku s tvojou aktivitou nám vieš poslať na <a href="mailto:obchod@activitypoint.xyz">obchod@activitypoint.xyz</a>
                                        <br />
                                    </li>
                                    <li class="custom-bullet">
                                        Nezabudni, zdieľaním myšlienky platformy ActivityPoint podporuješ aj vlastný kšeft.
                                    </li>
                                </ul>
                            </p>
                            <Button
                                onClick={() => setContacting((prev) => !prev)}
                                style={{
                                    marginTop: "1rem",
                                    marginBottom: "2rem",
                                    padding: "1rem 3rem",
                                    color: "white",
                                    background: "#ff0000",
                                }}
                            >
                                Nezáväzná žiadosť o registráciu
                            </Button>
                        </Grid.Column>

                        <Grid.Column
                            mobile={12}
                            tablet={6}
                            computer={6}
                            textAlign={"center"}
                            style={{ height: "auto" }}
                        >
                            <ImageGallery
                                images={[
                                    "/images/public/apbusiness/gallery-0.jpg",
                                    "/images/public/apbusiness/gallery-1.jpg",
                                    "/images/public/apbusiness/gallery-2.jpg",
                                    "/images/public/apbusiness/gallery-3.png",
                                    "/images/public/apbusiness/gallery-4.jpg",
                                ]}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>

            <ContactFormAPWalkIn opened={contacting} setOpenedFunc={setContacting} />
            <Footer />
        </div>
    );
}

